<template lang="pug">
  .payment-profiles
    transition-group(name="fade" tag="div")
      .row.profile-wrap(v-for="profile in profiles" :key="profile.paymentProfileId" data-mr-ass="payment-option")
        PaymentProfile(:profile="profile" edit=true remove=true)

    .row.text-center
      hr
      PaymentAddNewBtn

</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import PaymentProfile from './PaymentProfile';
  import PaymentAddNewBtn from "./PaymentAddNewBtn";

  export default {
    name: "Payments",

    components: {
      PaymentAddNewBtn,
      PaymentProfile
    },

    beforeCreate() {
      this.$store.dispatch('payments/initPaymentProfiles');
    },

    computed: {
      ...mapState('payments', [
        'savingProfile',
        'profiles',
        'lastSavedProfile'
      ]),

      ...mapGetters('subscriptions', [
        'activeSubscriptions'
      ]),
    },

    methods: {
      ...mapActions('payments', [
        'updateSubsModal'
      ]),

      ...mapActions('subscriptions', [
        'updateSubsToUpdate'
      ])
    },

    watch: {
      savingProfile(newVal) {
        //- when ever we save a new payment we need to check if that payment is a new default, if so
        //- prompt the user if they would like to update all their active subs
        if (newVal === false && this.lastSavedProfile.paymentProfileId && this.lastSavedProfile.is_default && this.activeSubscriptions.length) {
          let subsToUpdate = this.activeSubscriptions.filter(sub => {
            return sub.payment_id != this.lastSavedProfile.paymentProfileId;
          });

          if (subsToUpdate.length) {
            this.updateSubsToUpdate(subsToUpdate);
            this.updateSubsModal();
          }
        }
      }
    }
   }
</script>

<style scoped lang="stylus">
  .payment-profiles
    .profile-wrap
      margin 1.2em 0em

</style>